// ======================================================================
// File Name       : UserTopContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import { Component } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  exportUserCSV,
  getAllGroupOwnerFlag,
  getAttributeList,
  getGroupListAll,
  getUserGroupRelation,
  searchUser
} from '../../actions/UserAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import SelectGroupDlg from '../../components/group/SelectUserGroupDialog';
import UserList from '../../components/user/UserList';
import UserSearch from '../../components/user/UserSearch';
import { DORMANT_STATE, RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import { USER_TYPE } from '../../constants/UserConstants';
import * as actionType from '../../constants/actionTypes/page';
import { isSuperUser, showExportCSVSuccessMessage } from '../../utils/index';

class UserTopContainer extends Component {
  constructor() {
    super();
    this.state = {
      showSelectGroup: false,
      showExportModal: false,
      searchInfo: {
        userName: '',
        userType: USER_TYPE.ALL,
        loginId: '',
        managementAuthorityList: [],
        dormantState: DORMANT_STATE.INACTIVE,
        userAttributeKeyNum: 1,
        userAttributeSearchText: '',
        selectedGroup: {},
        userSortType: null,
        ascendingDescendingSort: 0,
        startPosition: 0,
        managementAuthoritySecernId: null,
        returnMaxNum: RETURN_MAX_NUM,
      },
      userList: [],
      groupList: [],
      groupRelation: {},
      groupInfo: {},
      mgtAuthorityList: [],
      recordNum: 0,
      isAllowShowSearchMessage: false,
      isInit: true,
      isShowLoginExportBtn: false,
      allGroupOwnerFlag: false,
    };

    this.handleSearchFormChange = this.handleSearchFormChange.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.onLoginExportBtnClick = this.onLoginExportBtnClick.bind(this);
  }

  componentWillMount() {
    const { dispatch, authedUser } = this.props;
    dispatch(getGroupListAll());
    if (this.props.parentPath === Path.USER_LIST) {
      this.setState({
        ...this.state,
        searchInfo: this.props.searchCondition,
        isInit: true,
      }, () => {
        this.getUserList(SELECT_TARGET_DATA.DATA);
      });
    } else {
      this.getUserList(SELECT_TARGET_DATA.DATA);
    }
    // Step 10.0.0 START
    const { userInfo: { displayUserType, userSecernId } } = authedUser;
    if (!isSuperUser(displayUserType)) {
      dispatch(getUserGroupRelation(userSecernId)).then(({ recordNum }) => {
        this.setState({ isShowLoginExportBtn: recordNum === 0 });
      });
    }
    // Step 10.0.0 END
    // Step 11.0.0.1 START
    if (isSuperUser(displayUserType) && authedUser.enterpriseManagementFunctionAuthorityInfo
      .superuserManagementAuthority > 0) {
      const searchParam = {
        superuser_secern_id: userSecernId,
        return_max_record_num: 5000,
        start_position: 0,
      };
      dispatch(getAllGroupOwnerFlag(searchParam, authedUser.institutionId)).then((allGroupOwnerFlag) => {
        this.setState({
          allGroupOwnerFlag,
        });
      })
    }
  }

  /**
   * Get user list
   *
   * @param {Interger} selectTargetData
   */
  getUserList(selectTargetData) {
    const { dispatch } = this.props;
    const searchInfo = { ...this.state.searchInfo };
    const userType = parseInt(searchInfo.userType, 10);
    searchInfo.userType = isNaN(userType) || userType === USER_TYPE.ALL ? null : userType;
    if (selectTargetData === SELECT_TARGET_DATA.DATA) {
      if (searchInfo.userAttributeSearchText !== '') {
        dispatch(getAttributeList(searchInfo)).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      } else {
        dispatch(searchUser(searchInfo, undefined)).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      }
    } else {
      dispatch(exportUserCSV(searchInfo)).then(() => {
        showExportCSVSuccessMessage();
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    const { userList, groupList, managementAuthorityList, recordNum, groupInfo } = user;
    this.setState({
      userList,
      recordNum,
      groupList,
      mgtAuthorityList: managementAuthorityList,
      groupInfo,
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.USER_LIST,
      searchCondition: this.state.searchInfo,
    });
  }

  handleSearchFormChange(event) {
    const { name, value } = event.target;
    let searchInfo = {};
    if (name === 'userType' && parseInt(value, 10) !== USER_TYPE.ADMIN) {
      searchInfo = {
        ...this.state.searchInfo,
        ...{ [name]: value, managementAuthorityList: [] },
      };
    } else if (name === 'dormantState') {
      searchInfo = {
        ...this.state.searchInfo,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    } else if (name === 'managementAuthoritySecernId') {
      const mgtAuthorityListSelected = [];
      let managementAuthoritySecernId = null;
      if (value !== null && value !== '') {
        mgtAuthorityListSelected.push(value);
        managementAuthoritySecernId = value;
      }
      searchInfo = {
        ...this.state.searchInfo,
        ...{ managementAuthorityList: mgtAuthorityListSelected },
        ...{ managementAuthoritySecernId },
      };
    } else {
      searchInfo = { ...this.state.searchInfo, ...{ [name]: value } };
    }
    this.setState({
      searchInfo,
    });
  }

  /**
 * Remove selected group
 */
  removeSelectedGroup() {
    const { searchInfo } = this.state;
    searchInfo.selectedGroup = {};
    this.setState({
      searchInfo,
    });
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    this.setState({ showSelectGroup: true });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   * @param {object} group
   */
  okSelectGroupDlg(group) {
    const searchInfo = {
      ...this.state.searchInfo,
      ...{ selectedGroup: group },
    };
    this.setState({
      showSelectGroup: false,
      searchInfo,
    });
  }

  /**
 * Handle search when click on search button
 *
 */
  handleSearchBtn() {
    this.setState(
      {
        searchInfo: { ...this.state.searchInfo, startPosition: 0 },
        isAllowShowSearchMessage: false,
        isInit: false,
      },
      () => {
        this.getUserList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  /**
   * Handle export cvs when click on export button
   */

  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  onExportDialogCancel() {
    this.setState({ showExportModal: false });
  }

  onExportDialogOk() {
    this.getUserList(SELECT_TARGET_DATA.CSV);
    this.setState({ showExportModal: false });
  }

  closeExportSuccessDialog() {
    this.setState({
      showExportSuccess: false,
    });
  }
  /**
 * Handle event when click on header of table, call API to sort data
 *
 * @param row
 */
  handleSortState(row) {
    const { searchInfo } = this.state;
    searchInfo.ascendingDescendingSort = row.sortState;
    searchInfo.userSortType = row.sortBy;
    this.setState(
      {
        searchInfo,
      },
      () => {
        this.getUserList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  /**
 * Handle event when user change page on paging
 * @param page
 */
  getStartEndData(startPosition) {
    this.setState(
      {
        searchInfo: { ...this.state.searchInfo, startPosition },
      },
      () => {
        this.getUserList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  // Step 10.0.0 START
  onLoginExportBtnClick() {
    const { history } = this.props;
    history.push(Path.LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD);
  }
  // Step 10.0.0 END

  render() {
    const {
      userList,
      recordNum,
      groupList,
      searchInfo,
      mgtAuthorityList,
      userGroupRelations,
      groupInfo,
      hoverIndex,
      isShowLoginExportBtn,
    } = this.state;
    const { authedUser } = this.props;
    const {
      isTrialExpire,
      userInfo: { displayUserType },
      managementFunctionAuthorityInfo: { authorityManagementAuthority },
      isOEMUser, // Step 11.2.1 TAS-18597
    } = authedUser;
    let isShowRoleSetting = authorityManagementAuthority !== MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;

    return (
      <Col sm={12} className="padding-left-clear">
        <MessageSearch
          recordNum={recordNum}
          resultList={userList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="padding-left-right-clear">
          <Col sm={3} className="padding-left-right-clear">
            <Header name="ユーザー管理" />
          </Col>
        </Col>
        <UserSearch
          {...this.state.searchInfo}
          recordNum={recordNum}
          groupList={groupList}
          managementAuthorityList={mgtAuthorityList}
          handleChange={this.handleSearchFormChange}
          removeSelectedGroup={this.removeSelectedGroup}
          getStartEndData={this.getStartEndData}
          showSelectGroupDlg={this.showSelectGroupDlg}
          onSearchBtnClick={this.handleSearchBtn}
          onExportBtnClick={this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT, null)}
          onLoginExportBtnClick={this.onLoginExportBtnClick}
          isShowLoginExportBtn={isShowLoginExportBtn}
          isSuperUser={isSuperUser(displayUserType)}
          allGroupOwnerFlag={this.state.allGroupOwnerFlag}
        />
        <UserList
          userList={userList}
          userGroupRelations={userGroupRelations}
          groupInfo={groupInfo}
          managementAuthorityList={mgtAuthorityList}
          handleSortState={this.handleSortState}
          searchInfo={searchInfo}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={this.state.searchInfo.startPosition}
        />
        <SelectGroupDlg
          showModal={this.state.showSelectGroup}
          selectedGroup={searchInfo.selectedGroup}
          groupList={groupList}
          onCancel={this.cancelSelectGroupDlg}
          onOK={this.okSelectGroupDlg}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onExportDialogOk}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  const { authedUser } = state.authed;
  return ({
    ...{ user: state.user },
    parentPath,
    searchCondition,
    authedUser,
  });
};

export default connect(mapStateToProps)(UserTopContainer);
